import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { Edit, Trash2, Users } from "react-feather";

const ToursTableRow = ({ tour }) => {

  const { user } = useContext(AuthContext)

  const path = "/tour/" + tour._id;
  const deletePath = "/delete/tour/" + tour._id;
  const editPath = "/edit/" + tour._id;
  const usersPath = "/tour/" + tour._id + "/users";

  if (!user) return (<></>);

  const iconSize = 20;

  return (
    <tr data-tour={tour._id}>
      <td>{tour.artist}</td>
      <td>
        <Link to={path}>{tour.name}</Link>
      </td>
      {
        tour.owners.includes(user.uid) &&
        (
          <td><Link to={usersPath} className="icon-button-link"><Users size={iconSize} /></Link></td>
        )
      }
      {
        tour.editors.includes(user.uid) &&
        (
          <>
          <td><Link to={editPath} className="icon-button-link"><Edit size={iconSize} /></Link></td>
          <td><Link to={deletePath} className="icon-button-link-warning"><Trash2 size={iconSize} /></Link></td>
          </>
        )
      }
      
    </tr>
  )

};

export default ToursTableRow;